import type { UserEntry } from "@/lib/stores/core-store";
import type { MentionUser } from "@/lib/tiptap-config";

export function toMentionUsers(
	users: Map<string, UserEntry>,
	shared: boolean
): Omit<MentionUser, "type">[] {
	return Array.from(users.values()).map((entry) => ({
		id: entry.profile.firebaseUid,
		firstName: entry.profile.givenName || undefined,
		lastName: entry.profile.familyName || undefined,
		preferredName: entry.profile.displayName ?? undefined,
		...(shared && entry.profile.organization
			? { organizationName: entry.profile.organization.name }
			: {}),
	}));
}
